import React from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useMyHrUserRolesDataByContract } from "my-hr/hooks";
import { useOcCurrentUserState, useOcPageSideMenu } from "oc/hooks";

interface MenuItem {
  id: string;
  label: string;
  roles: string[];
  notAllowedRoles?: string[];
}

interface OcPageSideMenuProps {
  stateId: string;
  menuDef: MenuItem[];
}

export const OcPageSideMenu: React.FC<OcPageSideMenuProps> = ({
  stateId,
  menuDef,
}) => {
  const { t } = useTranslation();

  let { contractCode } = useOcCurrentUserState();
  const { hasRole } = useMyHrUserRolesDataByContract({
    contract: contractCode,
  });

  const { state: selectedItem, setState: setSelectedItem } = useOcPageSideMenu({
    id: stateId,
    initialValue: menuDef[0].id,
  });

  const handleSelect = (itemId: string) => {
    setSelectedItem(itemId);
  };

  return (
    <Box>
      {menuDef.map((item) => {
        let hasRight = hasRole(item.roles, item.notAllowedRoles);
        if (!hasRight) return null;
        return (
          <Box
            key={item.id}
            width="240px"
            height="40px"
            display="flex"
            flexDirection="row"
            alignItems="center"
            paddingLeft="40px"
            onClick={() => handleSelect(item.id)}
            style={
              selectedItem === item.id
                ? {
                    backgroundColor: "white",
                    borderLeft: "4px solid #cc0033",
                  }
                : { cursor: "pointer" }
            }
          >
            <Box
              id={item.id}
              style={{ fontSize: "14px", letterSpacing: "0.25px" }}
            >
              {t(item.label)}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default OcPageSideMenu;
